<template>
  <!-- 尾部 -->
  <div class="footer">
    <div class="content">
      <div class="contain">
        <div class="l">
          <img src="@/assets/img/index/icon/logo_white.png" />
          <div class="font">全流程一体化生鲜供应链系统</div>
          <div class="font font_top">为食材供应链提供整体数字化可控解决方案</div>
          <ul>
            <li @click="share_wx()"><img src="@/assets/img/index/icon/navigation_5weixin.svg" /></li>
            <li @click="share_wx()"><img src="@/assets/img/index/icon/navigation_6pengyouquan.svg" /></li>
            <li @click="share('qzone')"><img src="@/assets/img/index/icon/navigation_7QQkongjian.svg" /></li>
            <li @click="share('sina')"><img src="@/assets/img/index/icon/navigation_8weibo.svg" /></li>
          </ul>
        </div>
        <div class="r">
          <ul>
            <li>
              <div class="f_r_title">系统介绍</div>
            </li>
            <li><span>订单管理</span></li>
            <li><span>采购协同</span></li>
            <li><span>分拣配送</span></li>
            <li><span>食安监管</span></li>
            <li><span>财务管理</span></li>
            <li><span>数字化大屏</span></li>
          </ul>
          <ul>
            <li>
              <div class="f_r_title">客户案例</div>
            </li>
            <li><span>乐禾食品集团</span></li>
            <li><span>云南中康食品</span></li>
            <li><span>乐味餐饮</span></li>
            <li><span>国源供应链</span></li>
            <li><span>同创食品</span></li>
            <li><span>更多案例</span></li>
          </ul>
          <ul>
            <li>
              <div class="f_r_title">解决方案</div>
            </li>
            <li><span>数字农业</span></li>
            <li><span>农产品流通</span></li>
            <li><span>智慧后勤</span></li>
            <li><span>农产品监测全链条</span></li>
            <li><span>智慧农业商学院</span></li>
            <li><span>农业产业园规划运营</span></li>
          </ul>
          <ul>
            <li>
              <div class="f_r_title">关于我们</div>
            </li>
            <li><span class="link" @click="goTab('/about')">关于穗盈</span></li>
            <li><span class="link" @click="goTab('/aboutInfo')">资讯中心</span></li>
          </ul>
          <ul>
            <li>
              <div class="f_r_title">集团官网</div>
            </li>
            <li><span class="link" @click="goChildTab('https://www.visfarm.com')">智慧农业</span></li>
            <li><span class="link" @click="goChildTab('https://www.sciento.cn')">赛通科技</span></li>
            <li><span class="link" @click="goChildTab('https://www.megoai.com/index.html')">米果智能</span></li>
            <li><span class="link" @click="goChildTab('https://www.maixiaocai.com')">麦小菜</span></li>
          </ul>
<!--          <ul>-->
<!--            <li>-->
<!--              <div class="f_r_title">解决方案</div>-->
<!--            </li>-->
<!--            <li><span @click="goUrl('/solution', 'slt1')">行业发展碰到的难点</span></li>-->
<!--            <li><span @click="goUrl('/solution', 'slt2')">产品解决方案</span></li>-->
<!--            <li><span @click="goUrl('/solution', 'slt3')">系统核心功能板块</span></li>-->
<!--            <li><span @click="goUrl('/solution', 'slt4')">业务流程及优势</span></li>-->
<!--            <li><span @click="goUrl('/solution', 'slt5')">适用范围</span></li>-->
<!--          </ul>-->
<!--          <ul>-->
<!--            <li>-->
<!--              <div class="f_r_title">合作案例</div>-->
<!--            </li>-->
<!--            <li><span @click="goUrl('/cooperation', 'cpr1')">合作伙伴</span></li>-->
<!--            <li><span @click="goUrl('/cooperation', 'cpr2')">标杆案例</span></li>-->
<!--          </ul>-->
<!--          <ul>-->
<!--            <li>-->
<!--              <div class="f_r_title">智慧农业</div>-->
<!--            </li>-->
<!--            <li><span @click="goUrl('/institute', 'ist1')">智慧农业学院</span></li>-->
<!--            <li><span @click="goUrl('/institute', 'ist2')">智慧资讯</span></li>-->
<!--            <li><span @click="goUrl('/institute', 'ist3')">更新公告</span></li>-->
<!--          </ul>-->
<!--          <ul>-->
<!--            <li>-->
<!--              <div class="f_r_title">关于我们</div>-->
<!--            </li>-->
<!--            <li><span @click="goUrl('/about', 'ab1')">品牌介绍</span></li>-->
<!--            <li><span @click="goUrl('/about', 'ab2')">愿景与使命</span></li>-->
<!--            <li><span @click="goUrl('/about', 'ab3')">企业文化</span></li>-->
<!--            <li><span @click="goUrl('/about', 'ab4')">荣誉与资质</span></li>-->
<!--            <li><span @click="goUrl('/about', 'ab5')">业务覆盖范围</span></li>-->
<!--            <li><span @click="goUrl('/about', 'ab6')">团队介绍</span></li>-->
<!--          </ul>-->
          <ul class="last-ul">
            <li>
              <div class="f_r_title">关注我们</div>
            </li>
            <li><img src="@/assets/img/index/pic/code.jpg" /></li>
            <li>穗盈公众号</li>
            <li><img src="@/assets/img/index/icon/QRcode.jpg" /></li>
            <li>智慧农业服务号</li>
          </ul>
        </div>
      </div>
      <a class="copyRight" href="https://beian.miit.gov.cn/" >
        Copyright © 2026 广州市智慧农业服务股份有限公司 版权所有 All Rights Reserved. 粤ICP备15101694号-3
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created () {},
  methods: {
    goTab(url) {
      sessionStorage.setItem('tabUrl', url)
      window.scrollTo(0, 0)
      this.$router.push(url);
    },
    goChildTab(link) {
      window.open(link, '_blank');
    },
    goUrl(url, id) {
      sessionStorage.setItem(id, id)
      if (sessionStorage.getItem("tabUrl") != url) {
        sessionStorage.setItem('tabUrl', url)
        this.$router.push(url);
      }
    },
    //分享到微信朋友圈
    share_wx(){
      var el = document.getElementById('wx_share');
      el.target = '_new';
      el.click();
    },
    share (pType) {
      var pUrl = window.location.href; //当前的url地址
      this.shareys(pType, pUrl);
    },
    //以下shareys是主要的分享的api接口
    shareys (type, url) {
      const title = '智慧农业Erp官网'
      switch (type) {
        case "sina":
          url = "http://service.weibo.com/share/share.php?title=" + encodeURIComponent('「' + title + '」' + ' 点这里' + url);
          window.open(url);
          break;
        case "tqq":
          url = "http://share.v.t.qq.com/index.php?c=share&a=index&url=" + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
          window.open(url);
          break;
        case "qzone":
          url = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
          window.open(url);
          break;
        default:
          break;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pc/components/footer.vue